<!-- ===== MAIN SWAP MODAL ===== -->
<div class="modal-backdrop open" id="swapModal">
  <div class="modal-container" onclick="event.stopPropagation()">
    <!-- <div class="modal-header">
      <div class="modal-title">
        <div class="title-icon">⇄</div>
        Swap Component
      </div>
      <button class="close-btn" onclick="closeSwapModal()">✕</button>
    </div> -->
    <div class="modal-body">

      <!-- STEP 1 -->
      <div class="step-section">
        <div class="step-label">STEP 1 — SELECT VEHICLES</div>
        <div class="vehicles-row">
          <!-- Vehicle A -->
          <div class="vehicle-card vehicle-a" id="vehicleACard">
            <div class="vehicle-badge vehicle-badge-a">● VEHICLE A</div>
            <div id="vehicleAEmpty" class="empty-vehicle" (click)="openVehicleModal('A')" *ngIf="!selectedVehicle">
              <div class="add-icon">+</div>
              <div class="add-label">Click to select vehicle</div>
            </div>
            <div id="vehicleASelected" class="vehicle-info" *ngIf="selectedVehicle">
              <div class="vehicle-icon-wrap" id="vehicleAIcon">{{selectedType == 'Horse' ? '🚛': '🚚'}}</div>
              <div class="vehicle-text">
                <div class="vehicle-id" id="vehicleAId">{{selectedVehicle?.truckNumber ? selectedVehicle?.truckNumber : selectedVehicle?.fleetNumber}}</div>
                <div class="vehicle-model" id="vehicleAModel" *ngIf="selectedVehicle?.truckModel">{{selectedVehicle?.truckModel}}</div>
                <div class="vehicle-meta">
                  <span class="km-badge" id="vehicleAKm" *ngIf="selectedVehicle?.initialKmTravelled">Km: {{selectedVehicle?.initialKmTravelled}}</span>
                  <span class="live-badge" id="vehicleALive" *ngIf="selectedVehicle?.associatedTyres">{{selectedVehicle?.associatedTyres}} Live</span>
                </div>
              </div>
              <button class="change-btn" (click)="openVehicleModal('A')">Change</button>
            </div>
          </div>
          <!-- Swap -->
          <div class="swap-center">
            <button class="swap-circle" id="swapBtn" disabled onclick="swapVehicles()" title="Swap vehicles">⇄</button>
            <div class="swap-text">SWAP</div>
          </div>
          <!-- Vehicle B -->
          <div class="vehicle-card vehicle-b" id="vehicleBCard">
            <div class="vehicle-badge vehicle-badge-b">● VEHICLE B</div>
            <div id="vehicleBEmpty" class="empty-vehicle" (click)="openVehicleModal('B')" *ngIf="!selectedVehicleB">
              <div class="add-icon">+</div>
              <div class="add-label">Click to select vehicle</div>
            </div>
            <div id="vehicleBSelected" class="vehicle-info" *ngIf="selectedVehicleB">
              <div class="vehicle-icon-wrap" id="vehicleBIcon">{{selectedTypeB == 'HorseB' ? '🚛': '🚚'}}</div>
              <div class="vehicle-text">
                <div class="vehicle-id" id="vehicleAId">{{selectedVehicleB?.truckNumber ? selectedVehicleB?.truckNumber : selectedVehicleB?.fleetNumber}}</div>
                <div class="vehicle-model" id="vehicleAModel" *ngIf="selectedVehicleB?.truckMode">{{selectedVehicleB?.truckModel}}</div>
                <div class="vehicle-meta">
                  <span class="km-badge" id="vehicleAKm" *ngIf="selectedVehicleB?.initialKmTravelled">Km: {{selectedVehicleB?.initialKmTravelled}}</span>
                  <span class="live-badge" id="vehicleALive" *ngIf="selectedVehicleB?.associatedTyres">{{selectedVehicleB?.associatedTyres}} Live</span>
                </div>
              </div>
              <button class="change-btn" (click)="openVehicleModal('B')">Change</button>
            </div>
          </div>
        </div>
      </div>

      <!-- STEP 2 -->
      <div class="step-section">
        <div class="step-label">STEP 2 — COMPONENT TO SWAP</div>
        <div class="form-row three-col">
          <div class="form-group">
            <label class="form-label req">Component Type</label>
            <ng-select (change)="onTypeChange($event)" appendTo="body" placeholder="Select " class="field-input filled">
                <ng-option value="Tyre">Tyre</ng-option>
                <ng-option value="Battery">Battery</ng-option>
            </ng-select>
            <!-- <div class="field-hint">Tyre, Battery</div> -->
          </div>
          <div class="form-group">
            <label class="form-label req">Swap Date</label>
            <p-calendar class="dateRange" [(ngModel)]="swapDate"  dateFormat="dd/mm/yy" [showIcon]="false" placeholder=""  (onSelect)="onDateSelect($event)"></p-calendar>
          </div>
          <!-- <div class="form-group">
            <label class="form-label req">Reason</label>
            <ng-select appendTo="body" [(ngModel)]="reason" placeholder="Select " class="field-input filled">
                  <ng-option *ngFor="let item of statusListReason" [value]="item.value">{{item.label}}</ng-option>
              </ng-select>
          </div> -->
        </div>
      </div>

      <!-- STEP 3 -->
      <div class="step-section">
        <div class="step-label">STEP 3 — COMPONENT DETAILS</div>
        <div class="details-grid">
          <div class="detail-card detail-card-a">
            <div class="detail-card-header"><span class="dot-a">●</span><span id="detailATitle">FROM VEHICLE A</span></div>
            <div class="form-group" *ngIf="componentType == 'Tyre'">
              <label class="form-label req">Serial Number</label>
              
               <ng-select appendTo="body" [(ngModel)]="sourceComponentId" placeholder="Select " class="field-input filled">
                  <ng-option *ngFor="let item of tyreData" [value]="item.id">{{item.serialNumber}}</ng-option>
              </ng-select>
            </div>
            <div class="form-group" *ngIf="componentType == 'Battery'">
              <label class="form-label req">Serial Number</label>
              
               <ng-select appendTo="body" [(ngModel)]="sourceComponentId" placeholder="Select " class="field-input filled">
                  <ng-option *ngFor="let item of batteryData" [value]="item.id">{{item.serialNumber}}</ng-option>
              </ng-select>
            </div>
            <!-- <div class="form-group">
              <label class="form-label">Position on Vehicle</label>
              <select class="form-select" id="posA">
                <option>Front Right</option><option>Front Left</option><option>Rear Right</option><option>Rear Left</option><option>Center</option>
              </select>
            </div> -->
            <div class="form-group">
              <label class="form-label req">KM at Swap</label>
              <input class="form-input" type="number" id="kmA" placeholder="Enter KM..." [(ngModel)]="sourceKms" (keypress)="sharedService.isNumberOnly($event)" />
            </div>
            <div class="form-group">
              <label class="form-label req">Post Status</label>
              
               <ng-select appendTo="body" [(ngModel)]="sourceStatus" placeholder="Select " class="field-input filled">
                  <ng-option *ngFor="let item of statusList" [value]="item.value">{{item.label}}</ng-option>
              </ng-select>
            </div>
          </div>
          <div class="detail-card detail-card-b">
            <div class="detail-card-header"><span class="dot-b">●</span><span id="detailBTitle">FROM VEHICLE B</span></div>
            <div class="form-group" *ngIf="componentType == 'Tyre'">
              <label class="form-label req">Serial Number</label>
              <ng-select appendTo="body" [(ngModel)]="targetComponentId" placeholder="Select " class="field-input filled">
                  <ng-option *ngFor="let item of tyreDataB" [value]="item.id">{{item.serialNumber}}</ng-option>
              </ng-select>
            </div>
            <div class="form-group"  *ngIf="componentType == 'Battery'">
              <label class="form-label req">Serial Number</label>
              <ng-select appendTo="body" [(ngModel)]="targetComponentId" placeholder="Select " class="field-input filled">
                  <ng-option *ngFor="let item of batteryDataB" [value]="item.id">{{item.serialNumber}}</ng-option>
              </ng-select>
            </div>
            <!-- <div class="form-group">
              <label class="form-label">Position on Vehicle</label>
              <select class="form-select" id="posB">
                <option>Front Right</option><option>Front Left</option><option>Rear Right</option><option>Rear Left</option><option>Center</option>
              </select>
            </div> -->
            <div class="form-group">
              <label class="form-label req">KM at Swap</label>
              <input class="form-input" type="number" id="kmB" placeholder="Enter KM..." [(ngModel)]="targetKms" (keypress)="sharedService.isNumberOnly($event)"/>
            </div>
            <div class="form-group">
              <label class="form-label req">Swap Status</label>
              <ng-select appendTo="body" [(ngModel)]="targetStatus" placeholder="Select " class="field-input filled">
                                  <ng-option *ngFor="let item of statusList" [value]="item.value">{{item.label}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group notes-group">
        <label class="form-label">Notes / Remarks</label>
        <textarea class="form-textarea" [(ngModel)]="remark" id="notes" placeholder="Optional notes about this swap..."></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="close()">Cancel</button>
      <button class="btn-confirm" id="confirmBtn" (click)="confirmSwap()">Confirm Swap →</button>
    </div>
  </div>
</div>

<!-- ===== VEHICLE SELECT MODAL ===== -->
<div class="dropdown-overlay" id="dropdownOverlay" [ngClass]="vehicleModalPopup ? 'open':'close'">
<div class="modal-backdrop sub-modal" id="vehicleModal" (click)="closeVehicleModal()">
  <div class="vehicle-select-modal" onclick="event.stopPropagation()">
    <div class="vehicle-modal-header">
      <div class="vehicle-modal-title" id="vehicleModalTitle">🚛 Select Vehicle A</div>
      <button class="close-btn" (click)="closeVehicleModal()">✕</button>
    </div>
    <div class="justify-center">
        <div class="radio-button flex-wrap gap-4">
            <div class="flex items-center">
                <input 
              type="radio" 
              name="vehicleType" 
              value="Horse"
              [(ngModel)]="selectedType"
              (change)="onVehicleChange()" />
              <label for="horse" (change)="onVehicleChange()" class="ml-2 cursor-pointer">Horse</label>
            </div>
            <div class="flex items-center">
                <input 
                type="radio" 
                name="vehicleType" 
                value="Trailer"
                [(ngModel)]="selectedType"
                (change)="onVehicleChange()" />
                <label (change)="onVehicleChange()" for="trailer" class="ml-2 cursor-pointer">Trailer</label>
            </div>
        </div>
    </div>
    <div class="search-wrap">
      <!-- <span class="search-icon">🔍</span> -->
      <input class="search-input" type="text" id="vehicleSearch" placeholder="Search ..."  [(ngModel)]="searchText" (ngModelChange)="onSearchChange($event)"/>

      <!-- <input class="search-input" type="text" id="vehicleSearch" placeholder="Search ..." oninput="filterVehicles()"/> -->
    </div>
    <div class="vehicle-list" id="vehicleList">
      <div class="vehicle-option " *ngFor="let item of ListData" (click)="selectVehicle(item)" [ngClass]="selectedVehicle === item ? 'selected-opt' : 'ddd'">
          <div class="opt-icon">{{selectedType == 'Horse' ? '🚛': '🚚'}}</div>
          <div class="opt-info">
            <div class="opt-id">{{item?.truckNumber? item?.truckNumber : item?.fleetNumber}}</div>
            <div class="opt-desc" *ngIf="item?.truckModel">{{item?.truckModel}} · {{item?.truckSize}}</div>
          </div>
          <div class="opt-right">
            <div class="opt-km" *ngIf="item?.initialKmTravelled">KM: <span>{{item?.initialKmTravelled}}</span></div>
            <div class="opt-badge" *ngIf="item?.associatedTyres">{{item?.associatedTyres}} Live</div>
            <div style="margin-top:3px;"><span class="opt-type-tag">{{selectedType == 'Horse' ? 'Truck': 'Trailer'}}</span></div>
          </div>
        </div>
    </div>
  </div>
</div>
</div>




<!-- ===== VEHICLE SELECT MODAL ===== -->
<div class="dropdown-overlay" id="dropdownOverlay" [ngClass]="vehicleModalPopupB ? 'open':'close'">
<div class="modal-backdrop sub-modal" id="vehicleModal" (click)="closeVehicleModalB()">
  <div class="vehicle-select-modal" onclick="event.stopPropagation()">
    <div class="vehicle-modal-header">
      <div class="vehicle-modal-title" id="vehicleModalTitle">🚛 Select Vehicle B</div>
      <button class="close-btn" (click)="closeVehicleModalB()">✕</button>
    </div>

    <div class="justify-center">
          <div class="radio-button flex-wrap gap-4">
              <div class="flex items-center">
                 <input 
                type="radio" 
                name="vehicleTypeB" 
                value="HorseB"
                [(ngModel)]="selectedTypeB"
                (change)="onVehicleChangeB()" />
                <label for="horse" (change)="onVehicleChangeB()" class="ml-2 cursor-pointer">Horse</label>
              </div>
              <div class="flex items-center">
                  <input 
                  type="radio" 
                  name="vehicleTypeB" 
                  value="TrailerB"
                  [(ngModel)]="selectedTypeB"
                  (change)="onVehicleChangeB()" />
                  <label (change)="onVehicleChangeB()" for="trailer" class="ml-2 cursor-pointer">Trailer</label>
              </div>
          </div>
      </div>
    <div class="search-wrap">
      <!-- <span class="search-icon">🔍</span> -->
      <input class="search-input" type="text" id="vehicleSearch" placeholder="Search ..."  [(ngModel)]="searchTextB" (ngModelChange)="onSearchChangeB($event)"/>
    </div>
    <div class="vehicle-list" id="vehicleList">
      <div class="vehicle-option " *ngFor="let item of ListDataB" (click)="selectVehicleB(item)" [ngClass]="selectedVehicleB === item ? 'selected-opt' : 'ddd'">
          <div class="opt-icon">{{selectedTypeB == 'HorseB' ? '🚛': '🚚'}}</div>
          <div class="opt-info">
            <div class="opt-id">{{item?.truckNumber? item?.truckNumber : item?.fleetNumber}}</div>
            <div class="opt-desc" *ngIf="item?.truckModel">{{item?.truckModel}} · {{item?.truckSize}}</div>
          </div>
          <div class="opt-right">
            <div class="opt-km" *ngIf="item?.initialKmTravelled">KM: <span>{{item?.initialKmTravelled}}</span></div>
            <div class="opt-badge" *ngIf="item?.associatedTyres">{{item?.associatedTyres}} Live</div>
            <div style="margin-top:3px;"><span class="opt-type-tag">{{selectedType == 'Horse' ? 'Truck': 'Trailer'}}</span></div>
          </div>
        </div>
    </div>
  </div>
</div>
</div>